/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QueryDto } from '../../models/query-dto';

export interface QueriesQueryIdGet$Json$Params {
  queryId: string;
}

export function queriesQueryIdGet$Json(http: HttpClient, rootUrl: string, params: QueriesQueryIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryDto>> {
  const rb = new RequestBuilder(rootUrl, queriesQueryIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('queryId', params.queryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QueryDto>;
    })
  );
}

queriesQueryIdGet$Json.PATH = '/queries/{queryId}';
